<div
  class="payment-data__backdrop"
  [class.payment-data__backdrop--visible]="open()"
  aria-hidden="true"
></div>

@if (open()) {
  <section
    #dialog
    class="payment-data"
    role="dialog"
    aria-modal="true"
    aria-labelledby="payment-data-title"
    aria-describedby="payment-data-intro"
    tabindex="-1"
  >
    <header class="payment-data__header">
      <img
        class="payment-data__logo"
        src="/images/logo/logo.png"
        alt="Perrón Store"
        width="365"
        height="148"
      />
      <h2 id="payment-data-title" class="payment-data__title">{{ heading() }}</h2>
      <p id="payment-data-intro" class="payment-data__intro">{{ copy.intro }}</p>
      <!-- Countdown de la reserva flotante (solo contexto precompra). -->
      @if (countdownExpiresAt(); as expiresAt) {
        <p class="payment-data__timer">
          <app-countdown [expiresAt]="expiresAt" [label]="countdownLabel()" />
        </p>
      }
    </header>

    <dl class="payment-data__details">
      @if (method() === 'sinpe') {
        <div class="payment-data__row">
          <dt class="payment-data__label">SINPE Móvil</dt>
          <dd class="payment-data__value">{{ details.sinpe }}</dd>
        </div>
        <div class="payment-data__row">
          <dt class="payment-data__label">A nombre de</dt>
          <dd class="payment-data__value">{{ details.beneficiary }}</dd>
        </div>
      } @else {
        <div class="payment-data__row">
          <dt class="payment-data__label">Banco</dt>
          <dd class="payment-data__value">{{ details.transferBank }}</dd>
        </div>
        <div class="payment-data__row">
          <dt class="payment-data__label">Cuenta</dt>
          <dd class="payment-data__value">{{ details.transferAccount }}</dd>
        </div>
        <div class="payment-data__row">
          <dt class="payment-data__label">A nombre de</dt>
          <dd class="payment-data__value">{{ details.beneficiary }}</dd>
        </div>
      }

      @if (isLayaway()) {
        <div class="payment-data__row payment-data__row--total">
          <dt class="payment-data__label">{{ copy.depositLabel }}</dt>
          <dd class="payment-data__value">{{ amountColones() | crc }}</dd>
        </div>
        <div class="payment-data__row">
          <dt class="payment-data__label">{{ copy.remainingLabel }}</dt>
          <dd class="payment-data__value">{{ remainingColones() | crc }}</dd>
        </div>
      } @else {
        <div class="payment-data__row payment-data__row--total">
          <dt class="payment-data__label">{{ copy.totalLabel }}</dt>
          <dd class="payment-data__value">{{ amountColones() | crc }}</dd>
        </div>
      }
    </dl>

    @if (isLayaway()) {
      <p class="payment-data__layaway-hint">{{ layawayHint() }}</p>
    }

    @if (perronPointsHint(); as hint) {
      <p class="payment-data__pp-hint">
        <app-pp-coin [size]="16" />
        <span>{{ hint }}</span>
      </p>
    }

    <div class="payment-data__file">
      <span id="payment-data-file-label" class="payment-data__file-label">
        {{ copy.fileLabel }}
      </span>
      <label for="payment-data-file" class="payment-data__file-button">
        <svg
          class="payment-data__file-icon"
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
        {{ selectedFile() ? copy.fileButtonChange : copy.fileButton }}
      </label>
      <input
        id="payment-data-file"
        class="payment-data__file-input"
        type="file"
        accept="image/*"
        aria-labelledby="payment-data-file-label"
        aria-describedby="payment-data-file-hint"
        (change)="onFileChange($event)"
      />
      <p id="payment-data-file-hint" class="payment-data__file-hint">{{ copy.fileHint }}</p>
      @if (selectedFile(); as file) {
        <p class="payment-data__file-selected" role="status">✓ {{ file.name }}</p>
      }
    </div>

    @if (displayError(); as error) {
      <p #errorEl class="payment-data__error" role="alert">{{ error }}</p>
    }

    <p class="payment-data__note">{{ copy.note }}</p>

    <div class="payment-data__actions">
      <button
        type="button"
        class="payment-data__later"
        [disabled]="submitting()"
        (click)="onDismiss()"
      >
        {{ copy.ctaSecondary }}
      </button>
      <app-button
        variant="primary"
        size="md"
        type="button"
        [disabled]="!canFinalize()"
        [loading]="submitting()"
        (click)="onFinalize()"
      >
        {{ ctaPrimary() }}
      </app-button>
    </div>
  </section>
}
